/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable linebreak-style */
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import NavLink from 'components/NavLink';
import get from 'base-ui/dist/underline/get';
import { useAmp } from 'next/amp';
import { useDispatch } from 'react-redux';
import { addBookmark, deleteBookmark } from '../../state/slices/bookmarks';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const PostCard = ({ post, page, type, lazy, big, isCard, titleType, isAuthenticated, bookmarks, handleBookmarks }) => {
  const category = post?.categories?.length > 0 ? post.categories[0] : {};
  const thumbnail = get(post, 'featured_media.medium_large', '/images/no-image_medium.png');
  const permalink = post.permalink || `/${post.slug}/`;
  const Title = `${titleType}`;
  const dispatch = useDispatch();
  const [isBookmark, setIsBookmark] = useState(false);

  useEffect(() => {
    const result = bookmarks.find((item) => item === post.id);
    setIsBookmark(result !== undefined);
  }, [bookmarks, post]);

  const handleBookmarkClick = useCallback((e) => {
    e.preventDefault();
    if (isBookmark === false) {
      dispatch(addBookmark(post));
      handleBookmarks([...bookmarks, post.id]);
    } else if (isBookmark === true) {
      dispatch(deleteBookmark(post.id));
      handleBookmarks(bookmarks.filter((item) => item !== post.id));
    }
  }, [bookmarks, isBookmark, post]);

  return (
    <article key={post.id} className={`${isCard ? 'card ' : ''}content-post news`} style={type === 'slide' && useAmp() ? { width: '100%', padding: '0px', display: 'inline-block' } : {}}>
      <NavLink
        basePath={publicRuntimeConfig.PUBLIC_URL}
        as={`${permalink}`}
        to={`/article?permalink=${post.permalink}&page=${page}`}
        routerStrategy={'next'}
      >
        <div className="thumb" style={type === 'slide' && useAmp() ? { width: '50%' } : {}}>
          {
            isAuthenticated && (
              <span className="favorite" onClick={handleBookmarkClick}>
                {isBookmark ? (
                  <i className="fas fa-bookmark"></i>
                ) : (
                  <i className="far fa-bookmark"></i>
                )}
              </span>)
          }

          <div className="thumb-wrap" style={type === 'slide' && useAmp() ? { height: '220px' } : { }}>
            <Image
              src={thumbnail}
              srcSet={`${big ? get(post, 'featured_media.medium', '/images/no-image_medium.png') : get(post, 'featured_media.big-size_mobile', '/images/no-image_medium.png')} 425w,
                ${get(post, 'featured_media.medium_large', '/images/no-image_big.png')} 768w,
                ${get(post, 'featured_media.large', '/images/no-image_big.png')} 1024w`}
              alt={post.title}
              loading="lazy"
              width={314}
              height={220}
              layout="responsive"
              lazy={lazy}
            >
              {lazy && <div style={{ height: '100%', width: '100%', background: '#edeff4 no-repeat center center' }}></div>}
            </Image>
          </div>
        </div>
      </NavLink>
      <div className="caption" style={type === 'slide' && useAmp() ? { width: '50%', padding: '0 10px' } : {}}>
        { category?.permalink && (
          <div className="metas">
            <span className="meta cat">
              <NavLink
                basePath={publicRuntimeConfig.PUBLIC_URL}
                as={`${category?.permalink}`}
                to={`/category?permalink=${category.permalink}`}
                routerStrategy={'next'}
              >
                {category.name}
              </NavLink>
            </span>
          </div>
        )}
        <Title className="title">
          <NavLink
            basePath={publicRuntimeConfig.PUBLIC_URL}
            as={`${permalink}`}
            to={`/article?permalink=${post.permalink}`}
            routerStrategy={'next'}
          >
            {post.title}
          </NavLink>
        </Title>
        <p
          className="excerpt regent-grey-color"
          dangerouslySetInnerHTML={{
            __html: post.excerpt
          }}
          style={type === 'slide' && useAmp() ? { display: 'block' } : {}}
        />
      </div>
    </article>
  );
};

PostCard.propTypes = {
  post: PropTypes.object.isRequired,
  page: PropTypes.string,
  type: PropTypes.string,
  lazy: PropTypes.bool,
  big: PropTypes.bool,
  isCard: PropTypes.bool,
  titleType: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  bookmarks: PropTypes.array,
  handleBookmarks: PropTypes.func
};

PostCard.defaultProps = {
  lazy: true,
  page: 'article',
  titleType: 'span',
  isAuthenticated: false,
  bookmarks: [],
};

export default PostCard;
